import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        year: null,
        name: null,
        ip: null,
        version: null,
        deviceLimit: null,
        latestUpdate: null,
        spaceWarning: null,
        messages: [],
    },
    getters: {
        ...useGetters(),
        year: state => state.year,
        name: state => state.name,
        version: state => state.version,
        ip: state => state.ip,
        deviceLimit: state => state.deviceLimit,
        latestUpdate: state => state.latestUpdate,
        spaceWarning: state => state.spaceWarning,
        messages: state => state.messages,
    },
    mutations: {
        ...useMutators(),
        setup(state, data) {
            Object.keys(data).forEach((key) => {
                if (typeof state[key] === 'undefined') return;
                state[key] = data[key];
            });
        }
    },
    actions: {
        ...useActions(),
    },
}
